import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { observer } from 'mobx-react'
import { TransferCatalogSearchStore } from '@App/stores/search/transfer-catalog-search-store'
import CatalogTransferWizardStore from '@App/stores/rightsholder/catalogTransfer/catalog-transfer-wizard-store'

interface ExportTogglesForm {
    exportOption: 'fullExport' | 'useCurrentSearch'
}

interface ExportTogglesProps {
    transferCatalogSearchStore: TransferCatalogSearchStore
    catalogTransferStore: CatalogTransferWizardStore
    onValueChange: (useCurrentSearch: boolean) => void
    currentValue: boolean | undefined
}

const ExportTogglesForm = ({
    transferCatalogSearchStore,
    catalogTransferStore,
    onValueChange,
    currentValue,
}: ExportTogglesProps) => {
    const { register, subscribe } = useForm<ExportTogglesForm>({
        defaultValues: {
            exportOption: currentValue === undefined ? undefined : currentValue ? 'useCurrentSearch' : 'fullExport',
        },
    })

    const selectedPublishersWorksCount = catalogTransferStore.sourcePublishers.reduce(
        (sum, publisher) => sum + (publisher.worksCount ?? 0),
        0
    )
    const fullCatalogCount =
        selectedPublishersWorksCount ||
        catalogTransferStore.currentCatalogTransfer?.sourcePublishers?.reduce(
            (sum, publisher) => sum + (publisher.totalWorks ?? publisher.worksCount ?? 0),
            0
        ) ||
        0
    const currentSearchCount = transferCatalogSearchStore.worksRightsHolder?.count

    useEffect(() => {
        const callback = subscribe({
            formState: {
                values: true,
            },
            callback: ({ values }) => {
                onValueChange(values.exportOption === 'useCurrentSearch')
            },
        })
        return () => callback()
    }, [subscribe])

    return (
        <div className="verify-works-export-options">
            <form>
                <div className="export-options">
                    <div className="export-radio-button-wrapper">
                        <label>
                            <input type="radio" value="fullExport" {...register('exportOption', { required: true })} />
                            <div>
                                <strong>
                                    Select All Works {fullCatalogCount && <>({fullCatalogCount.toLocaleString()})</>}
                                </strong>
                                <span className="export-option-subtext">
                                    Click this button to select all of the works currently registered to this Publisher
                                </span>
                            </div>
                        </label>
                    </div>
                    <div className="export-radio-button-wrapper">
                        <label>
                            <input
                                type="radio"
                                value="useCurrentSearch"
                                {...register('exportOption', { required: true })}
                            />
                            <div>
                                <strong>
                                    Select Specific Works{' '}
                                    {currentSearchCount && <>({currentSearchCount.toLocaleString()})</>}
                                </strong>
                                <span className="export-option-subtext">
                                    Click this button to select only those works currently registered to this Publisher
                                    that appear in your search results.
                                </span>
                            </div>
                        </label>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default observer(ExportTogglesForm)
